// extracted by mini-css-extract-plugin
export default {"selectWrapper":"Select_selectWrapper__XZMip","placeholder":"Select_placeholder__uEO4q","selectWrapper__dropdown":"Select_selectWrapper__dropdown__kVrv8"};